import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Information Collection",
    blocks: [
      { type: "p", text: "Delta GreenX may collect personal information including:" },
      { type: "ul", items: [
        "Names, email addresses, telephone numbers",
        "Job titles and business affiliations",
        "Geographic locations",
        "Company registration details",
        "Investor profiles and onboarding responses",
        "Uploaded documents",
        "Browser information, IP information, access metadata",
        "Clickstream behavior, session behavior, and platform interaction patterns",
      ]},
      { type: "p", text: "Delta GreenX may also collect strategic business data voluntarily submitted by users, including:" },
      { type: "ul", items: [
        "Sourcing interests and trade corridor preferences",
        "Product categories and procurement requirements",
        "Investment criteria",
        "Strategic partnership interests",
      ]},
    ],
  },
  {
    heading: "Purpose of Data Processing",
    blocks: [
      { type: "p", text: "Collected information may be processed for:" },
      { type: "ul", items: [
        "Identity verification",
        "Onboarding review",
        "Fraud prevention",
        "Business matching",
        "Operational optimization",
        "Investor qualification",
        "Compliance screening",
        "Strategic intelligence analysis",
        "Security monitoring",
        "Customer support",
        "Analytics improvement",
        "Platform integrity",
      ]},
    ],
  },
  {
    heading: "Data Storage and Security",
    blocks: [
      { type: "p", text: "User data may be processed, stored, encrypted, archived, backed up, analyzed, or retained within infrastructure providers, cloud systems, operational databases, or compliance environments operated directly by Delta GreenX or authorized infrastructure partners." },
      { type: "p", text: "While commercially reasonable security practices are implemented, users acknowledge that no system is entirely immune from cyber threats." },
    ],
  },
  {
    heading: "Prohibited Data Abuse",
    blocks: [
      { type: "p", text: "Users may not upload:" },
      { type: "ul", items: [
        "False documentation",
        "Misleading commercial claims",
        "Fraudulent identity information",
        "Competitor intelligence submissions",
        "Manipulated documents",
        "Unlawful content",
      ]},
      { type: "p", text: "Any fraudulent submission may result in permanent access restriction, internal investigation, or legal escalation." },
    ],
  },
  {
    heading: "Retention Rights",
    blocks: [
      { type: "p", text: "Delta GreenX may retain user data for purposes including:" },
      { type: "ul", items: [
        "Compliance and audit requirements",
        "Dispute resolution",
        "Forensic investigation",
        "Fraud prevention",
        "Business continuity",
        "Regulatory cooperation",
        "Platform protection",
      ]},
      { type: "p", text: "Such retention may continue even after account termination where legally permissible." },
    ],
  },
  {
    heading: "No Sale of Data",
    blocks: [
      { type: "p", text: "Delta GreenX does not sell personal data, commercial data, business data, or uploaded documents to third parties." },
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy & Data Protection Policy"
      eyebrow="Legal · Privacy"
      effective="May 1, 2026"
      lastUpdated="May 1, 2026"
      intro={[
        "Delta GreenX is committed to protecting personal, professional, technical, and commercial information submitted to the platform.",
        "By accessing or using this platform, you acknowledge that you have read and understood this Privacy Policy.",
      ]}
      sections={sections}
      contact="legal@deltagreenx.com"
    />
  );
}
